// extracted by mini-css-extract-plugin
module.exports = {"categoryCard":"CategoryCard_categoryCard__PwQQi","selected":"CategoryCard_selected___20oY"};